import * as React from "react";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import JobType from "../../../../../model/job/JobType";
import {updateJobType} from "../../../../../store/action/jobType/jobType";
import {OnFailure, OnSuccess} from "../../../../../store/action/actionHelpers";
import EditJobTypeFormView from "./EditJobTypeFormView";
import Toast from "../../../../helper/Toast";
import {notifyBugsnagAndShowToast} from "../../../../../utils/Utils";

interface IComponentProps {
	/**
	 * On close button click.
	 */
	onClose: () => void;
	/**
	 * Job type to edit
	 */
	editedJobType: JobType;
}

interface IDispatchProps {
	updateJobType: (jtId: string, jobType: JobType, onSuccess: OnSuccess, onFailure: OnFailure) => void
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

type Props = IComponentProps & IDispatchProps

class EditJobTypeForm extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {isSubmitting: false};
		this.onSubmit = this.onSubmit.bind(this);
	}

	render() {
		return (
			<EditJobTypeFormView onSubmit={this.onSubmit}
								 onCancel={this.props.onClose}
								 isSubmitting={this.state.isSubmitting}
								 editedJobType={this.props.editedJobType}/>
		);
	}

	onSubmit(data: JobType) {
		this.setState({isSubmitting: true}, () => {
			this.props.updateJobType(
				this.props.editedJobType.id,
				data,
				() => {
					this.setState({isSubmitting: false}, () => {
						Toast.success("Job type updated", "Job type update");
						this.props.onClose();
					});
				},
				(err) => {
					this.setState({isSubmitting: false},
						() => {
							notifyBugsnagAndShowToast(err, "Job type update");
						});
				}
			);
		});
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>, props: IComponentProps) {
	return {
		updateJobType: (jtId: string, jobType: JobType, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(updateJobType(jtId, jobType, onSuccess, onFailure))
	};
}

export default connect(null, mapDispatchToProps)(EditJobTypeForm);
